import React from "react";

import PropTypes from "prop-types";
import IconWithTooltip from 'shared/react_components/IconWithTooltip';

import { namePadding } from "./Header.module.scss";

const StaticName = ({ name, error }) => {
  return (
    <div className={namePadding}>
      {name}
      {error &&
      <IconWithTooltip
        icon="error"
        className="text-danger"
      >
        Failed to fetch name. Please reload to try again.
      </IconWithTooltip>
      }
    </div>
  );
};

StaticName.propTypes = {
  name: PropTypes.PropTypes.string.isRequired,
  error: PropTypes.bool
};

export default StaticName;
